import ngLocale from "@angular/common/locales/en";
import { enUS as datefnsLocale } from "date-fns/locale";
import { en_US as nzLocale } from "ng-zorro-antd/i18n";
import { LocaleBundle } from "@webapp/localization/models/localization.models";

nzLocale.DatePicker.lang["shortDate"] = "MM/dd/yyyy";
nzLocale.DatePicker.lang["longDate"] = "MMMM dd, yyyy";

export const locale: LocaleBundle = { ngLocale, nzLocale, datefnsLocale };
